<template>
  <div>
      <el-table
              :data="rows"
              style="width: 100%">
          <el-table-column
                  prop="org_name"
                  label="Org Name"
                  sortable
          >
          </el-table-column>
          <el-table-column
              prop="user_name"
              label="User Name"
              sortable
          >
          </el-table-column>
          <el-table-column
              prop="user_created_date.dc"
              label="User Created Date (DC)"
              sortable
          >
          </el-table-column>
          <el-table-column
              prop="last_login_date.dc"
              label="Last Login (DC)"
              sortable
          >
          </el-table-column>

          <el-table-column
              prop="last_login_date.relative"
              label="Last Login (relative)"
          >
          </el-table-column>
          <el-table-column
              prop="last_major_action_date.dc"
              label="Last Major Action (DC)"
              sortable
          >
          </el-table-column>
          <el-table-column
              label="Last Major Action"
              sortable
          >
              <template slot-scope="scope">
                  <a :href="scope.row.last_major_action_url">
                  {{scope.row.last_major_action}}
                  </a>
              </template>
          </el-table-column>
          <el-table-column
              label="Last Major Action Extent"
              sortable
          >
              <template slot-scope="scope">
                  <a :href="'/extents/' + scope.row.last_major_action_extent.id">
                      {{scope.row.last_major_action_extent.name}}
                  </a>
              </template>
          </el-table-column>
      </el-table>
  </div>

</template>

<script>
export default {
    name: "OrganizationsStatus",
    props: ['count'],
    data() {
        return {
            rows: [],
        }
    },
    mounted() {
        console.log("OrganizationsStatus is mounted")
        let url = '/api/orgs/status/' + this.count
        console.log('about to request ' + url)
        axios.get(url)
            .then(response => {
                this.rows = response.data.rows
            })
            .catch(error => {
                console.log('oops')
                console.log(error)
            })
    },
}
</script>

<style scoped>

</style>